import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';

import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';

import { HeaderComponent } from './header/header.component';
import { CapturaComponent } from './captura/captura.component';
import { HomeComponent } from './home/home.component';
import { ResumoBatchMesComponent } from './home/resumo-batch-mes/resumo-batch-mes.component';
import { ResumoBatchPdvComponent } from './home/resumo-batch-pdv/resumo-batch-pdv.component';
import { RelatorioIntervencoesComponent } from './home/relatorio-intervencoes/relatorio-intervencoes.component';
import { ErrosImportacaoComponent } from './erros-importacao/erros-importacao.component';
import { ZipsContagemComponent } from './zips-contagem/zips-contagem.component';
import { MonitoramentoProcessosComponent } from './monitoramento-processos/monitoramento-processos.component';
import { ListagemComponent } from './listagem/listagem.component';
import { DetalheComponent } from './detalhe/detalhe.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { JsonService } from './_services/json.service';
import { LanguageService  } from './_services/language.service';
import { LoaderComponent } from './loader/loader.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HistoricoComponent } from './historico/historico.component';
import { LoginComponent } from './login/login.component';
import { GrupoUsuariosComponent } from './grupo-usuarios/grupo-usuarios.component';
import { ConfirmationDialogComponent } from './_helpers/confirmation-dialog.component';
import { DialogComponent } from './dialog/dialog.component';
import { OriginalOrderPipe } from './_helpers/original.order.pipe';
import { UppercaseDirective } from './_helpers/uppercase.directive';
import { LowercaseDirective } from './_helpers/lowercase.directive';
import { SmartCaseDirective  } from './_helpers/smart-case.directive';
import { LowercaseOnChangeDirective  } from './_helpers/lowercase-on-change.directive';
import { LowercaseCustomPipe } from './_helpers/lowercase-custom.pipe';
import { ClearOnAltDDirective } from './_helpers/clear-on-alt-d.directive';
import { NumeroDe1a100Directive } from './_helpers/numero-de1a100.directive';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ImageAloneComponent } from './image-alone/image-alone.component';
import { GroupListComponent } from './group-list/group-list.component';
import { GroupDetailComponent } from './group-detail/group-detail.component';
import { GroupDetailV2Component } from './group-detail-v2/group-detail-v2.component';
import { DirectoryListComponent } from './directory-list/directory-list.component';
import { DirectoryDetailComponent } from './directory-detail/directory-detail.component';
import { PdvListComponent } from './pdv-list/pdv-list.component';
import { PdvDetailComponent } from './pdv-detail/pdv-detail.component';
import { TooltipPageComponent } from './tooltip-page/tooltip-page.component';
import { TooltipTextComponent } from './common/tooltip-text/tooltip-text.component';
import { AuthCalbackComponent } from './auth-calback/auth-calback.component';
import { ListCounterComponent } from './common/list-counter/list-counter.component';
import { ImageBoxComponent } from './common/image-box/image-box.component';
import { DoctorFormComponent } from './detalhe/doctor-form/doctor-form.component';
import { DoctorFormPendingComponent } from './detalhe-pending-issues/doctor-form-pending/doctor-form-pending.component';
import { ProductFormComponent } from './detalhe/product-form/product-form.component';
import { InstitutionFormComponent } from './detalhe/institution-form/institution-form.component';
import { InstitutionFormPendingComponent } from './detalhe-pending-issues/institution-form-pending/institution-form-pending.component';
import { UserPerformanceComponent } from './user-performance/user-performance.component';
import { UserPerformanceReviewsComponent } from './user-performance-reviews/user-performance-reviews.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FormatTimePipe } from './_helpers/format-time.pipe';
import { FormatMinutesPipe } from './_helpers/format-minutes.pipe';

import { DetalhePendingIssuesComponent } from './detalhe-pending-issues/detalhe-pending-issues.component';
import { ProductFormPendingComponent } from './detalhe-pending-issues//product-form-pending-issues/product-form-pending.component';
import { ListagemPendingIssuesComponent } from './listagem-pending-issues/listagem-pending-issues.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    CapturaComponent,
    HomeComponent,
    ResumoBatchMesComponent,
    ResumoBatchPdvComponent,
    RelatorioIntervencoesComponent,
    ErrosImportacaoComponent,
    ZipsContagemComponent,
    MonitoramentoProcessosComponent,
    DetalheComponent,
    ListagemComponent,
    HeaderComponent,
    LoaderComponent,
    HistoricoComponent,
    LoginComponent,
    GrupoUsuariosComponent,
    ConfirmationDialogComponent,
    DialogComponent,
    OriginalOrderPipe,
    UppercaseDirective,
    LowercaseDirective,
    SmartCaseDirective,
    LowercaseOnChangeDirective,
    LowercaseCustomPipe,
    ImageAloneComponent,
    ClearOnAltDDirective,
    GroupListComponent,
    GroupDetailComponent,
    GroupDetailV2Component,
    NumeroDe1a100Directive,
    DirectoryListComponent,
    DirectoryDetailComponent,
    PdvListComponent,
    PdvDetailComponent,
    TooltipPageComponent,
    TooltipTextComponent,
    AuthCalbackComponent,
    ListCounterComponent,
    ImageBoxComponent,
    DoctorFormComponent,
    DoctorFormPendingComponent,
    ProductFormComponent,
    InstitutionFormComponent,
    InstitutionFormPendingComponent,
    UserPerformanceComponent,
    UserPerformanceReviewsComponent,
    FormatTimePipe,
    FormatMinutesPipe,
    DetalhePendingIssuesComponent,
    ListagemPendingIssuesComponent,
    ProductFormPendingComponent,
    SidebarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CdkAccordionModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatButtonModule,
    MatTabsModule,
    MatFormFieldModule,
    BaseChartDirective,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    JsonService,
    LanguageService,
    LoaderComponent,
    DetalheComponent,
    provideCharts(withDefaultRegisterables()),
    provideAnimationsAsync('noop'),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  exports: [
    LoaderComponent,
    UppercaseDirective,
    LowercaseDirective,
    SmartCaseDirective,
    LowercaseOnChangeDirective,
    ClearOnAltDDirective,
    NumeroDe1a100Directive,
    TooltipTextComponent 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
